export const customStyles = {
    content: {
        background: 'transparent',
        position: 'absolute',
        top: '50%',
        left: '55%',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        maxWidth: '700px',
        maxHeight: '400px',
        border: 'none'
    },
    overlay: {
        background: 'rgba(3, 13, 51, 0.6)',
        backdropFilter: 'blur(5px)'
    }
}
